import React from 'react';
import { useNavigate } from 'react-router-dom';

import cs from 'classnames';

import Icon from './shared/Icon/Icon';
import Button from './shared/Button/Button';

const NotFound = ({ portal = 'portal', className }) => {
  const navigate = useNavigate();

  const handleNavigate = () => navigate(`/${portal}`);

  return (
    <div
      className={cs(
        'relative z-10 flex h-full flex-col content-center items-center justify-center gap-11',
        className
      )}>
      <Icon icon="illustration-not-found" />
      <div className="flex flex-col items-center">
        <h1 className="text-2xl font-500 leading-[30px] text-primary-900">Page not found</h1>
        <p className="!pt-2 font-400 leading-6 text-neutral-600">
          This page could not be found. Return to the dashboard to continue.
        </p>
        <Button
          text="Back to dashboard"
          style="outlined"
          variant="link"
          icon="dashboard-mono"
          iconSize={18}
          size="small"
          className="!mt-6 !py-2 !pl-4 !pr-4"
          onClick={handleNavigate}
        />
      </div>
    </div>
  );
};

export default NotFound;
